import loggingService from '@/services/util/loggingService'
//import dateService from '../util/dateService'

var serviceName = 'letterTemplateService'
var path = '/LetterTemplate/'
var isDebug = false

function getHeader (http) {
    loggingService.log(isDebug, serviceName, 'getHeader')
    return http.get(path + 'GetHeader')
}

function getHeaderByCountyId (http, countyId) {
    loggingService.log(isDebug, serviceName, 'getHeaderByCountyId')
    return http.get(path + 'GetHeaderByCountyId?countyId=' + countyId)
}

function saveHeader (http, dto) {
    return http.put(path + 'SaveHeader', dto)
}

function getTemplate (http, id) {
    loggingService.log(isDebug, serviceName, 'getTemplate')
    return http.get(path + 'GetTemplate?templateId=' + id)
}

function listTemplateByCountyId (http, id) {
    loggingService.log(isDebug, serviceName, 'listTemplateByCountyId')
    return http.get(path + 'listTemplateByCountyId?countyId=' + id)
}

function listCaseTemplates (http) {
    loggingService.log(isDebug, serviceName, 'listCaseTemplates')
    return http.get(path + 'listCaseTemplates')
}

function saveTemplate (http, dto) {
    return http.put(path + 'SaveTemplate', dto)
}

function listDatafield (http) {
    return http.get(path + 'ListDatafield')
}

function letterTemplateDataFieldMerge (http, letterDto) {
    return http.post(path + 'LetterTemplateDataFieldMerge', letterDto)
}

export default {
    getHeader: getHeader,
    getHeaderByCountyId: getHeaderByCountyId,
    saveHeader: saveHeader,
    getTemplate: getTemplate,
    listTemplateByCountyId: listTemplateByCountyId,
    listCaseTemplates: listCaseTemplates,
    saveTemplate: saveTemplate,
    listDatafield: listDatafield,
    letterTemplateDataFieldMerge: letterTemplateDataFieldMerge
}
